import type { MarketVariants } from '@/lib/i18n'

export type Slide10FinaleCopy = {
  eyebrow: string
  title: string
  body: string
  toolkitHeading: string
  toolkitDescription: string
  /** Screen-reader label for the toolkit link. */
  toolkitCta: string
  closing: string
}

export const copy: MarketVariants<Slide10FinaleCopy> = {
  US: {
    eyebrow: 'Course complete',
    title: 'You’re ready.',
    body:
      'You know how scams work. You can spot the signals. You’ve built habits that make you harder to target. And you know what to do if something slips through.',
    toolkitHeading: 'Print your emergency card.',
    toolkitDescription:
      'One page with the right numbers for your country, with space for the rest. Print it and keep it somewhere handy.',
    toolkitCta: 'Open the printable card',
    closing:
      'Share what you’ve learned with someone you care about. That’s how we protect each other.',
  },
  ar: {
    eyebrow: 'اكتملت الدورة',
    title: 'أنت على أتمّ الاستعداد.',
    body:
      'أنت تعرف كيف يعمل الاحتيال. وتستطيع رصد الإشارات. وبنيت عادات تجعل استهدافك أصعب. وتعرف ماذا تفعل إذا تسلّل شيء ما.',
    toolkitHeading: 'اطبع بطاقة الطوارئ الخاصة بك.',
    toolkitDescription:
      'صفحة واحدة تضم الأرقام الصحيحة لبلدك، مع مساحة لإضافة الباقي. اطبعها واحتفظ بها في مكان قريب.',
    toolkitCta: 'افتح البطاقة القابلة للطباعة',
    closing:
      'شارك ما تعلّمته مع شخص تهتم لأمره. هكذا نحمي بعضنا بعضاً.',
  },
}
